import { Box } from '@mui/material';
import BaseTypography from 'components/typography/BaseTypography';
import BaseImage from 'components/image/BaseImage';
import CommunityImage from 'assets/images/Community_1.webp';
import React from 'react';
import BaseButton from 'components/button/BaseButton';
import { sectionStyles } from 'layouts/pages/landing-page/components/sections/sectionStyles';

export function JoinDiscordSection() {
	return (
		<Box
			id="join-discord-section"
			sx={{
				color: 'colors.light6',
				display: 'flex',
				flexDirection: { xs: 'column', sm: 'row' },
				justifyContent: 'space-between',
				gap: { xs: '24px', sm: 0 },
			}}
		>
			<Box
				id="join-discord-text-section"
				sx={{
					...sectionStyles.headerStyle,
					order: { xs: 1, sm: 0 },
				}}
			>
				<BaseTypography variant="d3_zodiak_medium">
					Join the Community. Create More, Together.
				</BaseTypography>
				<BaseTypography variant="t2_v3_regular" sx={{ color: 'colors.text_medium' }}>
					Be part of a growing network creating next-gen marketing and ecommerce content.
				</BaseTypography>
				<BaseButton
					id="create-now-button"
					sx={{
						...sectionStyles.buttonTypeBStyles,
						marginTop: '16px',
					}}
					href="https://discord.com/invite/rendernet-ai"
					target="_blank"
					rel="noopener noreferrer"
				>
					<BaseTypography variant="t2_medium" sx={{ textTransform: 'none' }}>
						Join our Discord
					</BaseTypography>
				</BaseButton>
			</Box>
			<Box
				id="join-discord-image"
				sx={{
					...sectionStyles.contentStyle,
					order: { xs: 0, tabletMid: 1 },
					width: { xs: '100%', sm: '40%' },
				}}
			>
				<BaseImage
					style={{
						width: '100%',
						borderRadius: '16px',
						objectFit: 'contain',
					}}
					src={CommunityImage}
				/>
			</Box>
		</Box>
	);
}
